import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DoorConfig from '../../../components/configuration/door/DoorConfig';
import DoorScheduleContainer from './DoorScheduleContainer';
import client, { url } from '../../../lib/api/client';
import qs from 'qs';

const DoorConfigContainer = ({ history }) => {
  const dispatch = useDispatch();
  const {
    club,
    socketKey,
  } = useSelector(({ club, socket }) => ({
    club: club.defaultClub,
    socketKey: socket.socketKey
  }));

  const [doorList, setDoorList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [selectedDoor, setSelectedDoor] = useState(null);

  const getDoorList = async () => {
    const queryString = qs.stringify({
        socketKey,
    });
    let itemRes = await client.get(`${url}/api/item/${club.clubID}?${queryString}`);
    if(itemRes.data && itemRes.data.result === 1) {
        setItemList(itemRes.data.infos);
    }
    let doorRes = await client.get(`${url}/api/door/${club.clubID}?${queryString}`);
    if(doorRes.data && doorRes.data.result === 1) {
        setDoorList(doorRes.data.infos);
        if(doorRes.data.infos.length > 0 && !selectedDoor) {
            setSelectedDoor(doorRes.data.infos[0]);
        }
    }
  }

  useEffect(() => {
    getDoorList();
  }, [])

  const setCondition = (doorID, condition) => {
    console.log("setCondition : ", doorID, condition);
    const newDoorList = doorList.map((item) =>
      item.id === doorID ? { ...item, condition } : item
    );
    setSelectedDoor(newDoorList.find((item) => item.id === doorID));
    setDoorList(newDoorList);
  }

  const setMembershipType = (doorID, membershipType) => {
    console.log("setMembershipType : ", doorID, membershipType);
    const newDoorList = doorList.map((item) =>
      item.id === doorID ? { ...item, membershipType, membershipList: membershipType === 0 ? [] : item.membershipList } : item
    );
    setSelectedDoor(newDoorList.find((item) => item.id === doorID));
    setDoorList(newDoorList);
  }

  const setMembershipList = (doorID, membershipList) => {
    console.log("setMembershipList : ", doorID, membershipList);
    const newDoorList = doorList.map((item) =>
      item.id === doorID ? { ...item, membershipList } : item
    );
    setSelectedDoor(newDoorList.find((item) => item.id === doorID));
    setDoorList(newDoorList);
  }

  const onSaveDoor = async () => {
    
    const queryString = qs.stringify({
        socketKey,
    });
    
    const msg = {
        attendActive:club.attendActive,
        faceActive:club.faceActive,
        qrActive:club.qrActive,
        clubDoorDeviceInfos:club.clubDoorDeviceInfos,
        clubDoorInfos:doorList,
    }

    let res = await client.patch(`${url}/api/clubs/club/doorupdate/${club.clubID}?${queryString}`, msg);
    console.log('setChangeDoorInfo : ', res.data)
    if(res && res.data && res.data.result == 1) {
        alert('출입문 정보가 수정되었습니다.')
        getDoorList();
    }
    else {
        alert('출입문 정보 수정에 실패하였습니다.')
    }
  }

  const onCancelDoor = async () => {
    console.log("onCancelDoor : ", selectedDoor);
    getDoorList();
  }

  return (
    <DoorConfig
        schedule={club && club.clubID && socketKey ? <DoorScheduleContainer key={`${club.clubID}:${socketKey}`} clubID={club.clubID} socketKey={socketKey} /> : null}
        doorList={doorList}
        itemList={itemList}
        selectedDoor={selectedDoor}
        setSelectedDoor={setSelectedDoor}
        setCondition={setCondition}
        setMembershipType={setMembershipType}
        setMembershipList={setMembershipList}
        onSaveDoor={onSaveDoor}
        onCancelDoor={onCancelDoor}
    />
  );
};

export default withRouter(DoorConfigContainer);
